module.exports = __webpack_public_path__ + "img/18.a73bb1e8.png";